// extracted by mini-css-extract-plugin
export default {"flex_rows":"FAQ_flex_rows__-AIgI","answer_section":"FAQ_answer_section__6R0qZ","question":"FAQ_question__yI1GC","control_icon":"FAQ_control_icon__xziUn"};